export default "__VITE_ASSET__e76dac89__"